import * as React from 'react';
import { useTheme } from 'styled-components';
import { AccountType } from 'src/types';
import {
  FailContainer,
  FailHeader,
  FailText,
  ImageContainer,
} from '../ConfirmationContainer.styles';
import LoginContainer from '../LoginContainer';

interface Props {
  headerText?: string;
  failText?: string | React.ReactNode;
  kind?: AccountType;
}

export const ResetPasswordFail = ({ headerText, failText, kind }: Props) => {
  const theme = useTheme();
  const emptyStateSrc = theme.isVaultVariant
    ? '/assets/empty-state.svg'
    : '/assets/empty-state-atlas.svg';
  return (
    <LoginContainer
      includeForm={false}
      data-testid="password-confirmation"
      kind={kind ?? AccountType.App}
    >
      <FailContainer data-testid="app-password-reset-fail-message">
        <ImageContainer>
          <img src={emptyStateSrc} alt="Fail" width={'100%'} />
        </ImageContainer>
        <FailHeader>{headerText ?? 'Something went wrong'}</FailHeader>
        <FailText>
          {failText ??
            'Head back to the Vault App and try again. If the issue continues, reach out to us at techsupport@vaultplatform.com'}
        </FailText>
      </FailContainer>
    </LoginContainer>
  );
};

export default ResetPasswordFail;
